module.exports = __webpack_public_path__ + "c_static/img/2-1手机天猫购物车.3cc7d0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/2-1手机天猫购物车.jpg
// module id = 9RO2
// module chunks = 33